export const inchesToParts = (
	totalInches: number | null | undefined,
): { feet: string; inches: string } => {
	if (totalInches === null || totalInches === undefined)
		return { feet: "", inches: "" };

	const abs = Math.abs(Math.round(totalInches));

	return {
		feet: String(Math.floor(abs / 12)),
		inches: String(abs % 12),
	};
};

export const partsToInches = (feet: string, inches: string): number | null => {
	if (feet === "" && inches === "") return null;

	const f = feet === "" ? 0 : Number.parseInt(feet, 10);
	const i = inches === "" ? 0 : Number.parseInt(inches, 10);

	if (Number.isNaN(f) || Number.isNaN(i)) return null;

	return f * 12 + i;
};

export const formatLength = (
	totalInches: number | null | undefined,
): string => {
	if (totalInches === null || totalInches === undefined) return "";

	const { feet, inches } = inchesToParts(totalInches);

	return `${feet}' ${inches}"`;
};
